// pages/ForgotPassword.js
import React, { useState } from "react";
import axios from "axios";

import "../styles/UserForm.css";
import logo from "../assets/logo.png";
import { validateEmail } from "../utils/validators";


const ForgotPassword = () => {
  const [username, setUsername] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
      username: "",
  });
  const handleUsernameChange = (e) => {
      const value = e.target.value;
          setUsername(value);
          setErrors((prev) => ({
          ...prev,
          username: validateEmail(value),
      }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(false);
    if (!username) {
      setErrorMessage("Please enter the registered mail id");

      // Clear error message after 5 seconds
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return;
    }

    const newErrors = {};

    // Field-level validation
    const emailError = validateEmail(username);
    if (emailError) {
      newErrors.username = emailError;
    }

    setErrors(newErrors);

    // BLOCK LOGIN if any errors exist
    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors.username);
      return;
    }

    try {
      setLoading(true);
      await axios.post(`/api/forgot_password`, {
        username
      });
      
      setSuccessMessage(
        "An email has been sent. Please check your inbox."
      );
      setLoading(false);
    } catch(error) {
      if (error.response && error.response.data?.error?.message) {
        setErrorMessage(error.response.data.error.message);
      } else {
        setErrorMessage("Something went wrong. Please try again.");
      }
      setLoading(false);
    }

    // Clear error message after 5 seconds
    setTimeout(() => {
        setErrorMessage("");
        setSuccessMessage("");
    }, 5000);
  };

  return (
    <div className="page">
      <div className="card">
        <img src={logo} alt="Manis Logo" className="logo" />
        <h2 className="title">Forgot Password</h2>

        {errorMessage && (
          <div className="error">
            {errorMessage}
          </div>
        )}

        {successMessage && (
          <div className="success">
            {successMessage}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
          <label>Username</label>
            <input
              type="email"
              value={username}
              onChange={handleUsernameChange}
              placeholder="Enter your email address"
            />
          {errors.username && <small className="error-text">{errors.username}</small>}
          </div>
          <button className="button" type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
